import { gbp, useServiceCharge } from "../../utils/bookingCharges";

// One-line hint under the pickup/recipient address showing the collection/delivery charge.
// `charge` is that service's company setting; renders nothing when the charge is off.
function ChargeHelperText({ label, service, charge, address, latitude, longitude, className, style }) {
  const { loading, error, data } = useServiceCharge(charge, { address, latitude, longitude }, service);

  if (!charge?.enabled) return null;

  let text;
  if (loading) {
    text = `Calculating ${label.toLowerCase()}...`;
  } else if (error) {
    text = `Couldn't calculate the ${label.toLowerCase()} for this address.`;
  } else if (data) {
    text = `${label}: ${gbp(data.amount)}${data.type === "mile" ? ` (${Number(data.miles || 0).toFixed(2)} mi)` : ""}`;
  } else {
    text = `${label}: ${gbp(charge.rate_per_mile)} per mile, worked out from the address`;
  }

  return <p className={className} style={{ fontWeight: 600, ...style }}>{text}</p>;
}

export default ChargeHelperText;
